export default "/images/vendor/flag-icons/flags/1x1/jo.svg?039a42204bb9d4c08632301277733c18";